import { ROUTES } from 'b2b-apps/shop/routes/components/Router';
import { useUrlCreator } from 'b2b-apps/shop/routes/hooks';
import { getCategoryUrlParams } from 'b2b-apps/shop/routes/utils/url';

export const useProductCategoryUrl = (uri?: string): string => {
  const urlCreator = useUrlCreator();

  return uri ? `${urlCreator(ROUTES.category)}${getCategoryUrlParams(uri)}` : '#';
};
